/** @return True, if it's a promise, or false, if not.
    https://stackoverflow.com/questions/27746304/how-do-i-tell-if-an-object-is-a-promise
*/
export const isPromise = (promise) => {
  return Boolean(promise && promise.then);
};

const timedPromise = ({ secondsToWait, willResolve = true, message }) => {
  return new Promise( (resolve, reject) => {
    const done = willResolve ? resolve : reject;
    setTimeout( () => done( message ), secondsToWait * 1000 );
  });
};

export const resolveAfter = ( secondsToWait, message ) => timedPromise({ secondsToWait, willResolve: true, message });

export const rejectAfter = ( secondsToWait, message ) => timedPromise({ secondsToWait, willResolve: false, message });

const promiseInLimbo = new Promise( () => {}); // reuse one to minimize impact of never-resolving promises
export const neverResolve = () => promiseInLimbo; // we want neither resolution nor rejection

// stall a promise fulfillment
// useful to deprioritize a promise because
// promise callbacks are higher priority than setTimeout callbacks
// TODO: use requestIdleCallback if available
export const delayPromise = ( promiseToDelay, delay=0 ) => {
  let resolve;
  let reject;
  const delayedPromise = new Promise( (res, rej) => {
    resolve = res;
    reject = rej;
  });
  setTimeout( () => {
    promiseToDelay
    .then( (...all) => resolve(...all) )
    .catch( (...all) => reject(...all) );
  }, delay);
  return delayedPromise;
};
